module.exports = __webpack_public_path__ + "static/logo-ac9bdd1707852b4d7a72b8d0c084e69a.png";